var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
  fill: "#F5F5F9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7951 25.064C13.7951 25.64 14.2451 26.09 14.8211 26.09C15.2891 26.09 15.6671 25.838 15.8471 25.388L16.9091 22.958H23.0291L24.0551 25.316C24.2531 25.784 24.6131 26.09 25.1351 26.09C25.7291 26.09 26.1791 25.622 26.1791 25.028C26.1791 24.884 26.1431 24.722 26.0531 24.56L21.3731 14.12C21.1211 13.562 20.6891 13.22 20.0591 13.22H19.9511C19.3211 13.22 18.8711 13.562 18.6191 14.12L13.9391 24.56C13.8491 24.74 13.7951 24.902 13.7951 25.064ZM17.7551 20.996L19.9691 15.902L22.1831 20.996H17.7551Z",
  fill: "#171A20"
});

var SvgAIcon = function SvgAIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/a-icon.f8f92fdf.svg";
export { ForwardRef as ReactComponent };